package com.bikompanion.ui.settings

/**
 * What the settings window needs from its host.
 *
 * [notifications] is null where there is no permission to manage. [loadLicenses] returns the
 * AboutLibraries JSON each app module exports, because only the app sees its full dependency list.
 * [loadInstallId] is the anonymous ID ratings are stored under, which a rider needs to ask for them
 * to be deleted; null hides that option.
 */
data class SettingsPlatform(
    val versionName: String = "",
    val notifications: NotificationControls? = null,
    val loadLicenses: (suspend () -> String)? = null,
    val loadInstallId: (suspend () -> String)? = null,
)
